import React from "react";
import { Link } from "react-router-dom";
import { Twitter, Github } from "lucide-react";

function MediaCryptoLogo() {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="32" height="32" fill="#facc15"/>
      <polyline points="4,22 10,12 16,18 22,8 28,14" stroke="black" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
      <circle cx="28" cy="14" r="2" fill="black"/>
    </svg>
  );
}

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-black mt-24" data-testid="main-footer">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <MediaCryptoLogo />
            <span className="font-display font-bold text-xl text-white">
              Media<span className="text-yellow-400">Crypto</span>
            </span>
          </div>
          <p className="text-sm text-zinc-400 leading-relaxed">
            Real-time crypto intelligence and a high-signal community.
          </p>
        </div>
        <div>
          <h4 className="font-mono text-xs uppercase tracking-widest text-zinc-500 mb-4">Sections</h4>
          <ul className="space-y-2 text-sm">
            <li><Link className="text-zinc-300 hover:text-yellow-400" to="/news">News</Link></li>
            <li><Link className="text-zinc-300 hover:text-yellow-400" to="/categories">Categories</Link></li>
            <li><Link className="text-zinc-300 hover:text-yellow-400" to="/community">Community</Link></li>
            <li><Link className="text-zinc-300 hover:text-yellow-400" to="/about">About</Link></li>
            <li><Link className="text-zinc-300 hover:text-yellow-400" to="/privacy">Privacy Policy</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-mono text-xs uppercase tracking-widest text-zinc-500 mb-4">Categories</h4>
          <ul className="space-y-2 text-sm">
            <li><Link className="text-zinc-300 hover:text-yellow-400" to="/categories/bitcoin">Bitcoin</Link></li>
            <li><Link className="text-zinc-300 hover:text-yellow-400" to="/categories/ethereum">Ethereum</Link></li>
            <li><Link className="text-zinc-300 hover:text-yellow-400" to="/categories/altcoins">Altcoins</Link></li>
            <li><Link className="text-zinc-300 hover:text-yellow-400" to="/categories/market-analysis">Market Analysis</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-mono text-xs uppercase tracking-widest text-zinc-500 mb-4">Connect</h4>
          <div className="flex items-center gap-3">
            <a href="#" className="w-9 h-9 border border-white/10 flex items-center justify-center hover:border-yellow-400 hover:text-yellow-400 transition">
              <Twitter className="w-4 h-4" />
            </a>
            <a href="#" className="w-9 h-9 border border-white/10 flex items-center justify-center hover:border-yellow-400 hover:text-yellow-400 transition">
              <Github className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-white/5 py-6">
<div className="max-w-[1400px] mx-auto px-6 md:px-10 flex justify-between items-center text-xs font-mono text-zinc-500">
  <span>© {new Date().getFullYear()} MediaCrypto. All rights reserved.</span>
  <div className="flex items-center gap-4">
    <Link to="/about" className="hover:text-zinc-300 transition">About</Link>
    <Link to="/privacy" className="hover:text-zinc-300 transition">Privacy Policy</Link>
  </div>
</div>
      </div>
    </footer>
  );
}